export default "__VITE_ASSET__BgMt2Tec__"